import { useEffect, useState } from 'react';
import {
  INPUT_TYPE_CHECKBOX, INPUT_TYPE_SELECT_MULTI, INPUT_TYPE_SELECT_SINGLE,
  INPUT_TYPE_TEXT, INPUT_TYPE_TEXT_AREA, INPUT_TYPE_DATE, INPUT_TYPE_DATETIME
} from './componentConstants';
import MultiSelectControl from './MultiSelectControl';

const Input = ({
  label,
  name,
  type = INPUT_TYPE_TEXT,
  isRequired = false,
  isDisabled = false,
  value = '',
  includeNoneOption = true,
  toolTipText = '',
  style = {},
  optionsFunction = null,
  optionsFunctionParams = null,
  showSearch = true,
  className = '',
  showDots = false,
  onChange,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      if (optionsFunction) {
        const optionsFromDB = await optionsFunction(optionsFunctionParams);
        setOptions(optionsFromDB);
      }
    };
    fetchOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsFunction, JSON.stringify(optionsFunctionParams)]);

  const handleChange = (event) => {
    const value = type === 'checkbox' ? event.target.checked : event.target.value;
    onChange(value);
  };

  const handleMultiSelectChange = (event) => {
    if (Array.isArray(event)) {
      onChange(event);
      return;
    }
    const target = event?.target;
    if (!target?.selectedOptions) {
      return;
    }
    const selectedOptions = Array.from(target.selectedOptions, (option) => option.value);
    onChange(selectedOptions);
  };

  let inputElement;

  switch (type) {
    case INPUT_TYPE_TEXT_AREA:
      inputElement = (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          required={isRequired}
          disabled={isDisabled}
          title={toolTipText}
          style={style}
        />
      );
      break;
    case INPUT_TYPE_CHECKBOX:
      inputElement = (
        <input
          type={INPUT_TYPE_CHECKBOX}
          id={name}
          name={name}
          checked={!!value}
          onChange={handleChange}
          required={isRequired}
          disabled={isDisabled}
          title={toolTipText}
          style={style}
        />
      );
      break;
    case INPUT_TYPE_SELECT_SINGLE:
      inputElement = (
        <select
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          required={isRequired}
          disabled={isDisabled}
          title={toolTipText}
          style={style}
        >
          <option value="">-- All --</option>
          {!!includeNoneOption && (<option value="-1">-- None --</option>)}
          {!!options?.length && options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
      break;
    case INPUT_TYPE_SELECT_MULTI:
      inputElement = (
        <MultiSelectControl
          id={name}
          name={name}
          multiple="multiple"
          value={value}
          onChange={handleMultiSelectChange}
          required={isRequired}
          disabled={isDisabled}
          title={toolTipText}
          style={style}
          showSearch={showSearch}
          className={className}
          showDots={showDots}
          options={options}
        >
        </MultiSelectControl>
      );
      break;
    case INPUT_TYPE_DATE:
    case INPUT_TYPE_DATETIME:
      inputElement = (
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          required={isRequired}
          disabled={isDisabled}
          title={toolTipText}
          style={style}
        />
      );
      break;
    case INPUT_TYPE_TEXT:
    default:
      inputElement = (
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          required={isRequired}
          disabled={isDisabled}
          title={toolTipText}
          style={style}
        />
      );
  }

  return (
    <div className='form-field'>
      {label && <label htmlFor={name}>{label}</label>}
      {inputElement}
    </div>
  );
};

export default Input;
